import React from 'react'
import Link from 'components/Link';
import Img from 'gatsby-image';

const Card = (props) => {

  return (
    <Link to={props.slug}>
      <div className="home-card rounded shadow">
        <Img sizes={props.image}  backgroundColor="rgba(0,255,0,0.4)" className="home-card-image" />
        <div className="home-card-labels-container">
          <div className="home-card-labels">
            <h3>{props.title}</h3>
            <p>{props.subtitle}</p>
          </div>
        </div>
      </div>
    </Link>
  )
}
export default Card;



// WEBPACK FOOTER //
// ./src/pages/index/_homeCard.js